import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { siteData } from "../mock";
import { FASCIA_SPECIALTIES, COACHING_SPECIALTIES, CITIES } from "../data/specialties";
import { fasciaUrl, coachUrl, cityUrl } from "../data/urls";

export default function Footer() {
  return (
    <footer className="bg-[#f5ead9] text-[#5c554c] mt-24 border-t border-[#eee5d6]">
      <div className="container-tight py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="mb-4">
            <div className="font-serif text-[19px] text-[#2b2620] font-semibold">Fasciathérapie</div>
            <div className="text-[11px] tracking-[0.15em] text-[#c76d4b] font-medium uppercase">& Sport Santé</div>
          </div>
          <p className="text-sm text-[#5c554c] leading-relaxed">
            Coach sportif & praticien en fasciathérapie (méthode Tissual Balancing). Séances à domicile à Toulouse et au cabinet de Saint-Orens.
          </p>
          <div className="mt-6 flex gap-3">
            <a href="https://www.instagram.com/coach.sportif.fasciatherapie/" target="_blank" rel="noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-full border border-[#e0d3b8] bg-white flex items-center justify-center hover:border-[#c76d4b] hover:text-[#c76d4b] transition-colors">
              <Instagram size={16} />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61566321057979" target="_blank" rel="noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-full border border-[#e0d3b8] bg-white flex items-center justify-center hover:border-[#c76d4b] hover:text-[#c76d4b] transition-colors">
              <Facebook size={16} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-[#2b2620] font-semibold mb-4 text-sm">Fasciathérapie</h4>
          <ul className="space-y-2 text-sm text-[#5c554c]">
            <li><Link to="/fasciathérapie-toulouse" className="hover:text-[#c76d4b]">Vue d'ensemble</Link></li>
            {FASCIA_SPECIALTIES.map((s) => (
              <li key={s.slug}>
                <Link to={fasciaUrl(s.slug)} className="hover:text-[#c76d4b]">
                  {s.keyword.charAt(0).toUpperCase() + s.keyword.slice(1)}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-[#2b2620] font-semibold mb-4 text-sm">Sport santé</h4>
          <ul className="space-y-2 text-sm text-[#5c554c]">
            <li><Link to="/coach-domicile" className="hover:text-[#c76d4b]">Vue d'ensemble</Link></li>
            {COACHING_SPECIALTIES.map((s) => (
              <li key={s.slug}>
                <Link to={coachUrl(s.slug)} className="hover:text-[#c76d4b]">
                  {s.keyword.charAt(0).toUpperCase() + s.keyword.slice(1)}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-[#2b2620] font-semibold mb-4 text-sm">Villes desservies</h4>
          <ul className="space-y-2 text-sm text-[#5c554c] mb-6">
            {CITIES.map((c) => (
              <li key={c.slug}>
                <Link to={cityUrl(c.slug)} className="hover:text-[#c76d4b] inline-flex items-center gap-1">
                  <MapPin size={12} /> {c.short || c.name}
                </Link>
              </li>
            ))}
          </ul>
          <h4 className="text-[#2b2620] font-semibold mb-3 text-sm">Contact</h4>
          <ul className="space-y-2 text-sm text-[#5c554c]">
            <li className="flex items-center gap-2">
              <Phone size={13} className="text-[#c76d4b]" />
              <a href={`tel:${siteData.practitioner.phone.replace(/\s/g, "")}`} className="hover:text-[#c76d4b]">{siteData.practitioner.phone}</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={13} className="text-[#c76d4b]" />
              <a href="mailto:jc.happillon@gmail.com" className="hover:text-[#c76d4b]">jc.happillon@gmail.com</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#e0d3b8]">
        <div className="container-tight py-6 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-[#8a7d6a]">
          <p>© {new Date().getFullYear()} Jean-Christophe Happillon — Fasciathérapie & Sport Santé</p>
          <div className="flex gap-4">
            <Link to="/tarifs" className="hover:text-[#c76d4b]">Tarifs</Link>
            <Link to="/blog" className="hover:text-[#c76d4b]">Blog</Link>
            <Link to="/contact" className="hover:text-[#c76d4b]">Contact</Link>
            <Link to="/mentions-légales" className="hover:text-[#c76d4b]">Mentions légales</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
